import { memo, useCallback, useContext, useMemo } from 'react';
import { CallTopicContext } from '../../../contexts/CallTopicContext';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { Button } from 'foundations-components/transitional/components/Button';
import { RightIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const NextCallTopicButton = () => {
  const {
    setPlayerHeadLocation
  } = useContext(MediaPlaybackControlsContext);
  const {
    selectedTopicUtteranceIndex,
    selectedTopicUtterances
  } = useContext(CallTopicContext);
  const hasNextUtterance = useMemo(() => {
    if (!selectedTopicUtterances || selectedTopicUtteranceIndex === null) {
      return false;
    }
    return selectedTopicUtteranceIndex < selectedTopicUtterances.length - 1;
  }, [selectedTopicUtteranceIndex, selectedTopicUtterances]);
  const handleNextTopicUtteranceClick = useCallback(() => {
    if (selectedTopicUtteranceIndex !== null && hasNextUtterance && selectedTopicUtterances) {
      const newTopic = selectedTopicUtterances[selectedTopicUtteranceIndex + 1];
      setPlayerHeadLocation(newTopic.startTimeSeconds);
    }
  }, [hasNextUtterance, selectedTopicUtteranceIndex, selectedTopicUtterances, setPlayerHeadLocation]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "callTopicsNavButtons-next",
    size: "xs",
    use: "transparent",
    disabled: !hasNextUtterance,
    onClick: handleNextTopicUtteranceClick,
    marginInlineStart: "0",
    children: /*#__PURE__*/_jsx(RightIcon, {})
  });
};
export default /*#__PURE__*/memo(NextCallTopicButton);